import tokens from '@/PrimeVue/customDesignTokens';

export default {
  colorScheme: {
    light: {
      dropdown: {
        hoverBackground: tokens.input.background.color,
        background: tokens.button.background.colors.default,
        activeBackground: tokens.button.background.colors.default,
        focusRing: tokens.button.focusRing
      }
    }
  }
};